/**
 * StickerListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StickerListReq
 */
export interface StickerListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 表情包列表filter预设 */
  filter_preset?: string
  /** 表情类型 */
  type?: string
  /** 创建用户ID */
  creator_id?: any
  /** 表情来源 */
  source?: string
}

/**
 * StickerListReq Schema
 */
export const StickerListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    filter_preset: {
      description: '表情包列表filter预设',
      format: 'cons.StickerListFilterPreset',
      type: 'string',
      label: '表情包列表filter预设',
    },
    type: {
      description: '表情类型',
      format: '*cons.StickerType',
      type: 'string',
      label: '表情类型',
    },
    creator_id: {
      description: '创建用户ID',
      format: '*string',
      type: 'user',
      label: '创建用户ID',
    },
    source: {
      description: '表情来源',
      format: '*cons.StickerSource',
      type: 'string',
      label: '表情来源',
    },
  },
  type: 'object',
}
